<template>
  <div>
    <div v-if="loading" class="loading-state">
      <div class="loading-state__animation" aria-hidden="true">
        <img
          class="loading-state__gif"
          src="/img/loading.gif"
          alt=""
        >
      </div>

      <div
        class="tw-grid tw-grid-cols-1 tw-gap-4 md:tw-gap-6 lg:tw-grid-cols-2 xl:tw-grid-cols-3"
      >
        <div
          v-for="index in 6"
          :key="index"
          class="tw-h-[380px] tw-animate-pulse tw-rounded-card tw-border tw-border-slate-200 tw-bg-white tw-shadow-card lg:tw-h-[460px]"
        >
          <div class="tw-h-44 tw-rounded-t-card tw-bg-slate-100 sm:tw-h-56"></div>
          <div class="tw-space-y-4 tw-p-5">
            <div class="tw-h-4 tw-w-4/5 tw-rounded tw-bg-slate-100"></div>
            <div class="tw-h-4 tw-w-2/3 tw-rounded tw-bg-slate-100"></div>
            <div class="tw-h-14 tw-rounded-2xl tw-bg-slate-100"></div>
            <div class="tw-h-14 tw-rounded-2xl tw-bg-slate-100"></div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-else-if="!products.length"
      class="tw-rounded-card tw-border tw-border-dashed tw-border-slate-300 tw-glass tw-p-4 tw-text-center"
    >
      <empty-state
        :title="$l('emptyFiltersTitle')"
        :message="hasActiveFilters ? $l('emptyFiltersMessage') : $l('noResults')"
      />
    </div>

    <transition-group
      v-else
      name="product-list"
      tag="div"
      class="product-grid tw-grid tw-grid-cols-1 tw-gap-4 md:tw-gap-6 lg:tw-grid-cols-2 xl:tw-grid-cols-3"
      :class="{ 'product-grid--instant': instantTransitions }"
    >
      <shopping-item-card
        v-for="product in products"
        :key="cardProps(product).productKey || getFallbackKey(product)"
        v-bind="cardProps(product)"
      />
    </transition-group>
  </div>
</template>

<script>
import ShoppingItemCard from './ShoppingItemCard.vue';
import EmptyState from './EmptyState.vue';

export default {
  name: 'ProductGrid',
  components: {
    ShoppingItemCard,
    EmptyState,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    cardProps: {
      type: Function,
      required: true,
    },
    hasActiveFilters: {
      type: Boolean,
      default: false,
    },
    suppressTransitions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    instantTransitions() {
      return this.suppressTransitions;
    },
  },
  methods: {
    getFallbackKey(product) {
      const store = product.otherStores && product.otherStores[0];
      return store ? `${store.id}-${store.retailer}` : Math.random();
    },
  },
};
</script>

<style scoped>
.loading-state__animation {
  display: flex;
  justify-content: center;
  padding: 1.5rem 0 1rem;
}

.loading-state__gif {
  width: min(72vw, 14rem);
  height: auto;
  object-fit: contain;
}

.product-grid {
  position: relative;
}

.product-grid--instant .product-list-move,
.product-grid--instant .product-list-enter-active,
.product-grid--instant .product-list-leave-active {
  transition: none !important;
}
</style>
